import { extractErrorMessageString } from '@cloudapps/string-helper';
import { Box, Button, Card, CardContent, CircularProgress, Grid, TextField } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { Auth } from 'aws-amplify';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useDebouncedEffect from 'use-debounced-effect';

import { useFormFields } from '../../../../lib/hooks.lib';
import { useAuthStyles } from '../../../../shared/components/auth/styles';

const ChangePassword = (props) => {
  const classes = useAuthStyles();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [loading, setLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  useDebouncedEffect(
    () => {
      if (fields.newPassword && fields.confirmPassword) {
        if (fields.newPassword === fields.confirmPassword) {
          setPasswordsMatch(true);
        } else {
          setPasswordsMatch(false);
        }
      } else {
        setPasswordsMatch(true);
      }
    },
    500,
    [fields.newPassword, fields.confirmPassword]
  );

  const checkFormFilled = () => {
    return Object.values(fields).every(Boolean) && passwordsMatch;
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(currentUser, fields.oldPassword, fields.newPassword);
      setLoading(true);
      navigate('/applications');
    } catch (error) {
      console.error(error);
      setErrorMessage(extractErrorMessageString(error));
      setLoading(false);
    }
  };

  return (
    <div role="tabpanel" hidden={props.tab !== 'password'}>
      <Card>
        <CardContent>
          <form>
            <Grid container justifyContent="space-between" spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">Change your password</Typography>
              </Grid>
              {errorMessage && (
                <Grid item xs={12}>
                  <Alert
                    severity="error"
                    onClose={() => {
                      setErrorMessage(undefined);
                    }}
                  >
                    {errorMessage}
                  </Alert>
                </Grid>
              )}
              <Grid item xs={12}>
                <TextField
                  required
                  id="oldPassword"
                  name="oldPassword"
                  label="Old Password"
                  type="password"
                  fullWidth
                  value={fields.oldPassword}
                  onChange={handleFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  error={!passwordsMatch}
                  id="newPassword"
                  name="newPassword"
                  label="New Password"
                  type="password"
                  fullWidth
                  value={fields.newPassword}
                  onChange={handleFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  error={!passwordsMatch}
                  helperText={!passwordsMatch && 'Passwords do not match.'}
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Confirm New Password"
                  type="password"
                  fullWidth
                  value={fields.confirmPassword}
                  onChange={handleFieldChange}
                />
              </Grid>
              <Grid item xs={12}>
                <p className={classes.helpText}>
                  At least 8 characters with mix of upper and lowercase letters, numbers and special characters.
                </p>
              </Grid>
            </Grid>
            <Grid container justifyContent="center">
              <Grid item style={{ marginTop: '20px' }}>
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  className={classes.button}
                  disabled={!checkFormFilled()}
                  onClick={(e) => handleChangePassword(e)}
                >
                  Update
                  {loading && (
                    <Box ml={2} mt={1}>
                      <CircularProgress size="0.8rem" color={'inherit'} />
                    </Box>
                  )}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ChangePassword;
